import _ from 'underscore';
import { merge } from '@bingads-webui-universal/primitive-utilities';
import type { CommonStylesDefinition } from '../../types.d';


export const convertToLocalStyle = (style: CommonStylesDefinition) => _.object(
  _.map(_.keys(style), key => `& ${key}`),
  _.values(style)
);

export const convertToConcatStyle = (style: CommonStylesDefinition) => _.object(
  _.map(_.keys(style), key => `&${key}`),
  _.values(style)
);

export const convertToGlobalStyle = (style: CommonStylesDefinition | CommonStylesDefinition[]) => {
  let mergeStyle = style;
  if (_.isArray(style)) {
    mergeStyle = merge(
      {},
      ...style
    );
  }

  return {
    div: mergeStyle,
  };
};
